export default {
    cktoken: 'token',
    ckrftoken: 'rftoken'
};